import { FamilyAddress } from './models/FamilyAddress';

import { FAMILY_URL, FAMILY_ADDRESS_URL } from 'common/api/config';
import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';

export const getAddresses = () => withTokensIfNeeded<FamilyAddress[]>(`${FAMILY_URL}/address`);

export const addAddress = (address: FamilyAddress) =>
    withTokensIfNeeded<string>(`${FAMILY_URL}/address`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(address),
    });

export const editAddress = (address: FamilyAddress) =>
    withTokensIfNeeded(`${FAMILY_URL}/address/${address.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(address),
    });

export const deleteAddress = (id: FamilyAddress['id']) =>
    withTokensIfNeeded(`${FAMILY_URL}/address/${id}`, {
        method: 'DELETE',
    });

export const putDefaultAddress = (id: FamilyAddress['id']) =>
    withTokensIfNeeded(`${FAMILY_ADDRESS_URL}/${id}/default?api-version=1`, {
        method: 'PUT',
    });

export const getDefaultAddress = () =>
    withTokensIfNeeded(`${FAMILY_ADDRESS_URL}/default?api-version=1`, { method: 'GET' });
